import { NgModule } from '@angular/core';

import { IconFontModule } from '../icon-font/icon-font.module';
import { AlertMessageComponent } from './alert-message.component';

@NgModule({
    imports: [
        IconFontModule
    ],
    declarations: [
        AlertMessageComponent
    ],
    exports: [
        AlertMessageComponent
    ]
})
export class AlertMessageModule {
}
